import "./GreetingTemplate.scss";
import GreetingPreview from "../preview/GreetingPreview";
import NextAction from "../actions/NextAction";
class GreetingTemplate {
    structures() {
        return {
            title: {
                type: 'text',
                label: 'Title',
                placeholder: 'Greeting Title',
            },
            description: {
                label: 'Description',
                type: 'tinymce',
                placeholder: 'Description max 600 characters',
                rules: {
                    maxChar: 600, // 320 characters
                }
            }
        }
    }

    type() {
        return 'GreetingTemplate';
    }

    name() {
        return 'Beginning Slide';
    }
    iconType() {
        return this.structures().title.type;
    }
    canRearrange() {
        return false;
    }
    canRenameLabel() {
        return false;
    }
    getDuration() {
        return 60;
    }
    render(data, index, inEditor) {
        return (
            <GreetingPreview data={data} index={index} inEditor={inEditor} structures={this.structures()} />
        )
    }

    actions(data, index) {
        return (
            <NextAction label='Get Started' />
        );
    }
}

export default GreetingTemplate;
